import React from 'react';
import styles from "./ScreenshotCard.module.css"
import Screenshot, { ScreenshotSize, ScreenshotState } from '../../../../../../../chatbot/customerService/components/screenshotSelector/components/Screenshot';
import { ScreenshotDataModel } from '../../../../../../../chatbot/customerService/components/screenshotSelector/ScreenshotSelector';

interface ScreenshotCardProps {
    screenshot?: ScreenshotDataModel;
    state?: ScreenshotState;
    size?: ScreenshotSize;
    showRemoveButton?: boolean;
    onClickView?: (screenshot: ScreenshotDataModel) => void;
    onClickSelect?: (screenshot: ScreenshotDataModel) => void;
    onRemoveClicked?: () => void;
}

const ScreenshotCard: React.FC<ScreenshotCardProps> = ({
    screenshot,
    onClickView,
    onClickSelect
}) => {
    return (
        <div className={styles["container"]}>
            <div className={styles["screenshot-container"]}>
                <Screenshot
                    size='large'
                    state='normal'
                    screenshot={screenshot}
                    onClickView={() => { (screenshot && onClickView) && onClickView(screenshot) }}
                    onClickSelect={() => { (screenshot && onClickSelect) && onClickSelect(screenshot) }} />
            </div>
            <div className={styles["info-container"]}>
                <p><strong>Name: </strong>{screenshot?.name}</p>
                <p><strong>Description: </strong>{screenshot?.description}</p>
                <p><strong>Category: </strong>{screenshot?.category}</p>
            </div>
        </div>
    );
};

export default ScreenshotCard;